import React, { useRef } from "react";
import Footer from "../components/footer";
import NavBar from "../components/navbar";
import ParticleComponent from "../components/landing";
import FaqQuestions from "../components/FaqQuestions";
export default function Faq() {
  return (
    <div>
      <NavBar/>
      <div style={{ position: "relative" }}>
        <FaqQuestions/>
          <Footer/>
        </div>
      </div>
  );
}
